import { render, staticRenderFns } from "./KeyValueForm.vue?vue&type=template&id=19360f2d"
import script from "./KeyValueForm.vue?vue&type=script&lang=js"
export * from "./KeyValueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports